// application overrides

window.chatConfig = window.chatConfig || {};

// set to false to disable chat (config is not retrieved)
window.chatConfig.getConfig = true;

// location & name of npm package-supplied typing indicator. defaults to images/chatWriting.gif
window.chatConfig.typingIndicator = '';

// application-supplied chat server rest api url
// in config.js, defaults to https://dev-cwb.int.corp.sun/CONAV/chat/rest/api/
window.chatConfig.restUrl = '';

// if set, this will be added to the bottom of the chat window
// window.chatConfig.footerText = 'Any advice given is general in nature and your personal details will be used in line with our Privacy statement accessible at the bottom of the quote.'
window.chatConfig.footerText = '';

// application-supplied chat launchCode
window.chatConfig.launchCode = 'SuncorpTextChatCustomerDataED';

// callback function
window.chatConfig.onLogin = null;

// callback functions for close
window.chatConfig.onCloseByUser = null;
window.chatConfig.onCloseByAgent = null;
;
